<template>
    <div>
        <VueCtkDateTimePicker
            v-model="value"
            :label="label"
            :format="format"
            :formatted="formatted"
            :onlyTime="onlyTime"
        >
        </VueCtkDateTimePicker>
        <input type="hidden" :id="id" :name="name" v-model="value" v-bind:required="required">
    </div>
</template>

<script>
    import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';

    export default {
        components: {
            VueCtkDateTimePicker,
        },
        props: {
            id: {
                type: String,
                default: null,
            },
            name: {
                type: String,
                required: true,
            },
            value: {
                type: String,
                default: null,
            },
            required: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                label: 'Select Time',
                format: 'HH:mm:ss',
                formatted: 'HH:mm:ss',
                onlyTime: true,
            }
        }
    }
</script>
